import type { ArticleV2 } from 'types/capi/article';

import ModuleImpression from '~/components/ModuleImpression';
import ArticleCarousel from '~/modules/ArticleCarousel';
import RecentFeatures from '~/modules/RecentFeatures';

type Props = {
  articleType: ArticleV2['article_type'];
  latestNews?: ArticleV2['latest_news'];
  recentFeatures?: ArticleV2['recent_features'];
};

function RecentFeaturesModule({ items }: { items: Props['recentFeatures'] }) {
  if (!items?.length) return null;

  return (
    <div className="w-full bg-black">
      <ModuleImpression itemCount={items.length} moduleType="recent-features">
        <RecentFeatures title="Latest features" items={items} />
      </ModuleImpression>
    </div>
  );
}

function LatestNewsModule({ items }: { items: Props['latestNews'] }) {
  if (!items?.length) return null;

  return (
    <ModuleImpression itemCount={items.length} moduleType="article-latest-news">
      <ArticleCarousel items={items} title="Latest news" />
    </ModuleImpression>
  );
}

export default function ArticleFooter({
  articleType,
  latestNews,
  recentFeatures
}: Props) {
  if (articleType === 'news') {
    return (
      <div>
        <LatestNewsModule items={latestNews} />
        <RecentFeaturesModule items={recentFeatures} />
      </div>
    );
  }

  return (
    <div>
      <RecentFeaturesModule items={recentFeatures} />
      <LatestNewsModule items={latestNews} />
    </div>
  );
}
